import React, { useEffect, useState } from 'react';
import clockImg from '/fallbacks/alarm-clock.svg';
import discountImg from '/fallbacks/discount.svg';

const Message = () => {
	const messageConfig = window.post_template?.checkout_v3_widgets;

	// Static Textual Content

	const discountText = messageConfig.tr_checkout_v3_widgets_discountText;
	const discountBackground = messageConfig.checkout_v3_widgets_discountBackground;
	const discountBorder = messageConfig.checkout_v3_widgets_discountBorder;
	const discountTextColor = messageConfig.checkout_v3_widgets_discountTextColor;
	const discountIcon = messageConfig.checkout_v3_widgets_discountIcon;
	const clockText = messageConfig.tr_checkout_v3_widgets_clockText;
	const clockBackground = messageConfig.checkout_v3_widgets_clockBackground;
	const clockBorder = messageConfig.checkout_v3_widgets_clockBorder;
	const clockTextColor = messageConfig.checkout_v3_widgets_clockTextColor;
	const clockIcon = messageConfig.checkout_v3_widgets_clockIcon;
	const clockInterval = messageConfig.checkout_v3_widgets_clockInterval;

	// styles

	const discountStyle = {
		color: discountTextColor,
		borderColor: discountBorder,
		backgroundColor: discountBackground,
	};

	const clockStyle = {
		color: clockTextColor,
		borderColor: clockBorder,
		backgroundColor: clockBackground,
	};

	const oclockIcon = clockIcon ? clockIcon : clockImg;
	const discountIconImg = discountIcon ? discountIcon : discountImg;

	const [timer, setTimer] = useState('00:00');

	useEffect(() => {
		const countDownTimer = () => {
			let lastVisit = JSON.parse(localStorage.getItem('timerCount'));
			const now = new Date().getTime();

			if (lastVisit + clockInterval < now) {
				localStorage.removeItem('timerCount');
				localStorage.setItem('timerCount', JSON.stringify(now));
				lastVisit = now;
			}

			if (!lastVisit) {
				const date = new Date().getTime();
				localStorage.setItem('timerCount', JSON.stringify(date));
				lastVisit = date;
			}

			if (!lastVisit) return;

			const countdownDate = lastVisit + clockInterval * 1000;

			const countdown = setInterval(() => {
				const now = new Date().getTime();
				const distance = countdownDate - now;
				let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				let seconds = Math.floor((distance % (1000 * 60)) / 1000);

				const firstMinutesInt = minutes.toString().length !== 1 ? minutes.toString().charAt(0) : 0;
				const secondMinutesInt =
					minutes.toString().length !== 1 ? minutes.toString().charAt(1) : minutes.toString().charAt(0);
				const firstSecondsInt = seconds.toString().length !== 1 ? seconds.toString().charAt(0) : 0;
				const secondSecondsInt =
					seconds.toString().length !== 1 ? seconds.toString().charAt(1) : seconds.toString().charAt(0);

				const formattedTimer = `${firstMinutesInt}${secondMinutesInt}:${firstSecondsInt}${secondSecondsInt}`;

				setTimer(formattedTimer);

				if (distance < 0) {
					clearInterval(countdown);
					localStorage.removeItem('timerCount');
					setTimer('00:00');
				}
			}, 1000);
		};

		countDownTimer();
	}, []);

	return (
		<section className="message">
			<div className="message__discount" style={discountStyle}>
				<span className="message__img" style={{ backgroundImage: `url(${discountIconImg})` }}></span>
				<span className="message__text">{discountText}</span>
			</div>
			<div className="message__timer" style={clockStyle}>
				<span className="message__img" style={{ backgroundImage: `url(${oclockIcon})` }}></span>
				<span className="message__text">{clockText.replace('###react_time###', timer.toString())}</span>
			</div>
		</section>
	);
};

export default Message;
